import { CommandData } from '../../common';

export const close = (trigger?: string) => {
  const message: CommandData = {
    isFromBrainfish: true,
    command: 'closeHelpDrawer',
    trigger,
  };
  window.postMessage(message);
};
